import React from 'react'
import { StyledSelect, Props } from './styled'

export const Select: React.FC<Props> = (props: Props) => {
  return <StyledSelect {...props} />
}
